export default "__VITE_ASSET__3f963d40__"